import React, { useState, useEffect } from 'react';
import useWindowSize from '../hooks/useWindowSize';

const SliderComponent = () => {
  // Animation class management
  const [animated, setAnimated] = useState(true);
  const windowSize = useWindowSize();

  // Initialize animation when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimated(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Calculate responsive font sizes and positions
  const getResponsiveSizes = () => {
    const width = windowSize.width;

    if (width <= 576) {
      return {
        titleFontSize: '20px',
        titleLineHeight: '26px',
        mobileTitle: '22px',
        mobileLine: '28px',
        spacing: 40,
        decorHeight: 6,
        decorWidth: 100,
        circleSize: '300px',
        imageSize: '300px',
        overlap: '40px',
        mobileImageSize: '180px'
      };
    } else if (width <= 768) {
      return {
        titleFontSize: '26px',
        titleLineHeight: '32px',
        mobileTitle: '26px',
        mobileLine: '32px',
        spacing: 55,
        decorHeight: 8,
        decorWidth: 140,
        circleSize: '400px',
        imageSize: '400px',
        overlap: '60px',
        mobileImageSize: '220px'
      };
    } else if (width <= 992) {
      return {
        titleFontSize: '38px',
        titleLineHeight: '44px',
        mobileTitle: '32px',
        mobileLine: '38px',
        spacing: 70,
        decorHeight: 12,
        decorWidth: 200,
        circleSize: '600px',
        imageSize: '600px',
        overlap: '100px',
        mobileImageSize: '280px'
      };
    } else {
      return {
        titleFontSize: '52px',
        titleLineHeight: '60px',
        mobileTitle: '32px',
        mobileLine: '38px',
        spacing: 85,
        decorHeight: 15,
        decorWidth: 280,
        circleSize: '700px',
        imageSize: '700px',
        overlap: '120px',
        mobileImageSize: '320px'
      };
    }
  };

  const sizes = getResponsiveSizes();

  return (
    <div className="main-box" style={{ height: "100vh", maxHeight: "800px", overflow: "hidden", position: "relative" }}>
      <div className="prt-slider-wrapper" style={{ width: "100%", height: "100%" }}>
        {/* Vertical text area - positioned as in the CSS */}
        <div className="tm-quickdetails-area" style={{
          position: "absolute",
          left: 0,
          width: "100px",
          height: "90%",
          textAlign: 'center',
          textTransform: "uppercase",
          top: 0,
          padding: "70px 32px 0px 48px",
          zIndex: 20,
          display: windowSize.width <= 1400 ? "none" : "block",
          color: "var(--base-headingfont-color)",
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          fontFamily: "var(--base-headingfont)",
          backgroundColor: "#fff"
        }}>
          Tú equipo en nutrición, salud y bienestar<a target="_blank" rel="noreferrer noopener" href="tel:+34621234462"> • (+34 621 234 462)</a>
        </div>

        <div
          className="slider-container"
          style={{
            background: "transparent",
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div className="slider-content" style={{ position: "relative", width: "100%", height: "100%" }}>
            <div className="slider-slide" style={{ position: "relative", width: "100%", height: "100%" }}>
              <img
                src="/assets/images/slides/bg-image.jpg"
                alt="Fondo Equipo MAG"
                title="bg-image"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />

              {/* Animated elements */}
              <div className="slider-elements" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                {/* Desktop View */}
                <div style={{
                  width: "100%",
                  height: "100%",
                  display: windowSize.width <= 768 ? "none" : "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}>
                  <div style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: `calc(${sizes.circleSize} * 2 - ${sizes.overlap})`,
                    height: sizes.circleSize
                  }}>
                    {/* Image circle - positioned to the right (appears below the white circle) */}
                    <div
                      className={`animated-element ${animated ? 'animate__animated animate__fadeInRight' : ''}`}
                      style={{
                        position: "absolute",
                        right: "0",
                        top: "0",
                        width: sizes.imageSize,
                        height: sizes.imageSize,
                        borderRadius: "50%",
                        overflow: "hidden",
                        zIndex: 6,
                        animationDuration: "1s",
                        animationDelay: "0.2s"
                      }}
                    >
                      <img
                        src="/assets/images/slides/single-01.png"
                        alt="Ilustración de salud"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover"
                        }}
                      />
                    </div>

                    {/* White circle with text - positioned to the left (appears on top) */}
                    <div
                      className={`animated-element ${animated ? 'animate__animated animate__fadeInLeft' : ''}`}
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: sizes.circleSize,
                        height: sizes.circleSize,
                        zIndex: 7,
                        animationDuration: "1s"
                      }}
                    >
                      {/* White circle background */}
                      <img
                        src="/assets/images/slides/circle-img.png"
                        alt="Decorativo"
                        style={{
                          width: "100%",
                          height: "100%",
                          position: "absolute",
                          left: 0,
                          top: 0
                        }}
                      />

                      {/* Text inside the circle */}
                      <div style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: "20%",
                        paddingRight: "20%",
                        textAlign: "center"
                      }}>
                        {/* Main Service 1 */}
                        <div
                          className={`animated-element ${animated ? 'animate__animated animate__fadeInUp' : ''}`}
                          style={{
                            color: "#000000",
                            fontSize: sizes.titleFontSize,
                            lineHeight: sizes.titleLineHeight,
                            fontWeight: 600,
                            fontFamily: "Roboto Slab",
                            marginBottom: "10px",
                            animationDuration: "1s"
                          }}
                        >
                          NATUROPATÍA
                        </div>

                        {/* Decorative Shape */}
                        <div
                          className={`animated-element ${animated ? 'animate__animated animate__fadeInUp' : ''}`}
                          style={{
                            width: sizes.decorWidth,
                            height: sizes.decorHeight,
                            backgroundColor: "#ffc44a",
                            marginBottom: "15px",
                            animationDuration: "1s",
                            animationDelay: "0.1s",
                            display: windowSize.width <= 576 ? "none" : "block"
                          }}
                        ></div>

                        {/* Main Service 2 */}
                        <div
                          className={`animated-element ${animated ? 'animate__animated animate__fadeInUp' : ''}`}
                          style={{
                            color: "#000000",
                            fontSize: sizes.titleFontSize,
                            lineHeight: sizes.titleLineHeight,
                            fontWeight: 600,
                            fontFamily: "Roboto Slab",
                            marginBottom: "10px",
                            animationDuration: "1s",
                            animationDelay: "0.2s"
                          }}
                        >
                          ALIMENTACIÓN &
                        </div>

                        {/* Main Service 3 */}
                        <div
                          className={`animated-element ${animated ? 'animate__animated animate__fadeInUp' : ''}`}
                          style={{
                            color: "#000000",
                            fontSize: sizes.titleFontSize,
                            lineHeight: sizes.titleLineHeight,
                            fontWeight: 600,
                            fontFamily: "Roboto Slab",
                            marginBottom: "20px",
                            animationDuration: "1s",
                            animationDelay: "0.3s"
                          }}
                        >
                          PSICOLOGÍA
                        </div>

                        {/* Button */}
                        <div
                          className={`animated-element ${animated ? 'animate__animated animate__fadeInUp' : ''}`}
                          style={{
                            marginBottom: "10px",
                            animationDuration: "1s",
                            animationDelay: "0.4s"
                          }}
                        >
                          <a
                            href="/nosotros"
                            className="prt-btn"
                            style={{
                              backgroundColor: "#56aa46",
                              fontFamily: "Roboto Slab",
                              fontSize: "14px",
                              lineHeight: "24px",
                              fontWeight: 500,
                              padding: "13px 30px",
                              display: "inline-block",
                              color: "#fff",
                              textDecoration: "none"
                            }}
                          >
                            DESCUBRE MÁS
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile view for small screens */}
                {windowSize.width <= 768 && (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      padding: "0 15px"
                    }}>
                      {/* Image circle in mobile view */}
                      <div
                        className={`animated-element ${animated ? 'animate__animated animate__fadeInDown' : ''}`}
                        style={{
                          width: sizes.mobileImageSize,
                          height: sizes.mobileImageSize,
                          borderRadius: "50%",
                          overflow: "hidden",
                          marginBottom: "20px",
                          boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                          zIndex: 7
                        }}
                      >
                        <img
                          src="/assets/images/slides/single-01.png"
                          alt="Ilustración de salud"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                          }}
                        />
                      </div>

                      {/* White semi-transparent background */}
                      <div
                        className={`animated-element ${animated ? 'animate__animated animate__fadeInUp' : ''}`}
                        style={{
                          width: "100%",
                          maxWidth: "400px",
                          padding: "25px 15px",
                          backgroundColor: "rgba(255, 255, 255, 0.9)",
                          borderRadius: "20px",
                          zIndex: 8
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%"
                          }}
                        >
                          {/* Main Service 1 */}
                          <div style={{
                            color: "#000000",
                            fontSize: sizes.mobileTitle,
                            lineHeight: sizes.mobileLine,
                            fontWeight: 600,
                            fontFamily: "Roboto Slab",
                            marginBottom: "8px"
                          }}>
                            NATUROPATÍA
                          </div>

                          {/* Decorative Shape */}
                          <div style={{
                            backgroundColor: "#ffc44a",
                            height: sizes.decorHeight,
                            width: sizes.decorWidth,
                            margin: "8px auto 12px",
                            display: windowSize.width <= 400 ? "none" : "block"
                          }}></div>

                          {/* Main Service 2 */}
                          <div style={{
                            color: "#000000",
                            fontSize: sizes.mobileTitle,
                            lineHeight: sizes.mobileLine,
                            fontWeight: 600,
                            fontFamily: "Roboto Slab",
                            marginBottom: "8px"
                          }}>
                            ALIMENTACIÓN &
                          </div>

                          {/* Main Service 3 */}
                          <div style={{
                            color: "#000000",
                            fontSize: sizes.mobileTitle,
                            lineHeight: sizes.mobileLine,
                            fontWeight: 600,
                            fontFamily: "Roboto Slab",
                            marginBottom: "15px"
                          }}>
                            PSICOLOGÍA
                          </div>

                          {/* Button */}
                          <a
                            href="/nosotros"
                            className="prt-btn"
                            style={{
                              backgroundColor: "#56aa46",
                              fontFamily: "Roboto Slab",
                              fontSize: "14px",
                              lineHeight: "24px",
                              fontWeight: 500,
                              padding: "10px 20px",
                              display: "inline-block",
                              color: "#fff",
                              textDecoration: "none",
                              borderRadius: "4px",
                              marginTop: "5px"
                            }}
                          >
                            DESCUBRE MÁS
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderComponent;
